import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { APP_STORE_LINKS } from '../../constants/appLinks';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-400 px-6 py-12">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm">Sahayy</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/know-more" className="hover:text-white transition-colors">Know More</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm">Help</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/user-manual" className="hover:text-white transition-colors">User Manual</Link></li>
              <li><a href="https://chat.sahayy.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Chat with Commy</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/cookies" className="hover:text-white transition-colors">Cookie Policy</Link></li>
              <li><Link to="/gdpr" className="hover:text-white transition-colors">GDPR</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm">Download</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href={APP_STORE_LINKS.APPLE_APP_STORE} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  App Store
                </a>
              </li>
              <li>
                <a href={APP_STORE_LINKS.GOOGLE_PLAY} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  Google Play
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <Link to="/" className="text-white font-bold text-lg">Sahayy</Link>
            <p className="text-xs mt-1">
              © {year} Sahayy. All rights reserved. &nbsp;·&nbsp;{' '}
              <a href="https://www.freepik.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                Images by Freepik
              </a>
            </p>
          </div>
          <div className="flex gap-4">
            <a href="/" target="_blank" aria-label="Facebook" className="hover:text-white transition-colors">
              <FaFacebook size={18} />
            </a>
            <a href="/" target="_blank" aria-label="Instagram" className="hover:text-white transition-colors">
              <FaInstagram size={18} />
            </a>
            <a href="/" target="_blank" aria-label="Twitter" className="hover:text-white transition-colors">
              <FaTwitter size={18} />
            </a>
            <a href="/" target="_blank" aria-label="LinkedIn" className="hover:text-white transition-colors">
              <FaLinkedin size={18} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
